(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tamm-cart-tiers')) {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-tamm-continue]');
      if (button) button.closest('cart-drawer')?.querySelector('.drawer__close')?.click();
    });
    customElements.define('tamm-cart-tiers', class extends HTMLElement {
      connectedCallback() {
        this.drawer = this.closest('cart-drawer');
        this.renderCount(Number(this.dataset.count) || 0);
        if (!this.drawer) return;
        this.observer = new MutationObserver(() => {
          const counter = this.drawer.querySelector('cart-count');
          const count = counter ? Number(counter.textContent.trim()) : NaN;
          if (Number.isFinite(count)) this.renderCount(count);
        });
        this.observer.observe(this.drawer, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['data-cart-count']});
      }
      disconnectedCallback() { this.observer?.disconnect(); }
      renderCount(count) {
        count = Math.max(0, count);
        if (this.lastCount === count) return;
        this.lastCount = count;
        const next = count < 2 ? [2,10] : count < 3 ? [3,15] : [4,20];
        this.querySelector('.tamm-tiers-message').textContent = count >= 4
          ? '20% soodustuse kogus on saavutatud!'
          : 'Lisa veel ' + (next[0]-count) + ' ' + (next[0]-count === 1 ? 'toode' : 'toodet') + ', et saada ' + next[1] + '% soodustust!';
        this.style.setProperty('--tamm-progress', Math.min(count < 2 ? count / 6 * 100 : (count - 1) / 3 * 100, 100) + '%');
        this.querySelectorAll('[data-threshold]').forEach(el => el.classList.toggle('is-reached', count >= Number(el.dataset.threshold)));
      }
    });
  }

  if (!customElements.get('tamm-cart-timer')) {
    customElements.define('tamm-cart-timer', class extends HTMLElement {
      connectedCallback() {
        this.key = 'tamm-cart-timer-10min-v1';
        this.drawer = this.closest('cart-drawer');
        this.output = this.querySelector('[role="timer"]');
        if (!this.drawer || !this.output) return;
        this.visible = false;
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.sync();
        });
        this.visibilityObserver.observe(this);
        this.cartObserver = new MutationObserver(() => this.sync());
        this.cartObserver.observe(this.drawer, {attributes: true, attributeFilter: ['class']});
        const counter = this.drawer.querySelector('cart-count');
        if (counter) this.cartObserver.observe(counter, {childList: true, characterData: true, subtree: true});
      }
      disconnectedCallback() {
        clearInterval(this.interval);
        this.visibilityObserver?.disconnect();
        this.cartObserver?.disconnect();
      }
      sync() {
        clearInterval(this.interval);
        const count = Number(this.drawer.querySelector('cart-count')?.textContent.trim());
        if (this.drawer.classList.contains('is-empty') || count === 0) {
          try { sessionStorage.removeItem(this.key); } catch {}
          this.deadline = null;
          this.output.textContent = '10:00';
          return;
        }
        if (!this.visible) return;
        if (!this.deadline) {
          let saved = 0;
          try { saved = Number(sessionStorage.getItem(this.key)); } catch {}
          this.deadline = Number.isFinite(saved) && saved > 0 ? saved : Date.now() + 600000;
          try { sessionStorage.setItem(this.key, String(this.deadline)); } catch {}
        }
        this.tick();
        if (this.deadline > Date.now()) this.interval = setInterval(() => this.tick(), 1000);
      }
      tick() {
        const seconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        const minutes = String(Math.floor(seconds / 60)).padStart(2, '0');
        this.output.textContent = minutes + ':' + String(seconds % 60).padStart(2, '0');
        if (seconds === 0) clearInterval(this.interval);
      }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
